import { fetcher } from '@commenda/utils';
import { BASE_URL } from './helpers';
import { CreateFormsTemplateDto, CreateFormsTemplateResponse } from './types';

/**
 * Create a new form template
 */
export async function createFormsTemplate(
  data: CreateFormsTemplateDto
): Promise<{ success: boolean; data?: CreateFormsTemplateResponse }> {
  try {
    const res = await fetcher(BASE_URL, {
      method: 'POST',
      body: data,
    });

    if (!res.ok) {
      console.error('Failed to create form template:', await res.text());
      return { success: false };
    }

    const responseData = (await res.json()) as CreateFormsTemplateResponse;
    return {
      success: true,
      data: responseData,
    };
  } catch (err) {
    console.error('Error creating form template:', err);
    return { success: false };
  }
}
